export const notFound = {
  title: 'Page not found · Keval Langalia',
  eyebrow: '404 · Page not found',
  heading: 'A little off the map.',
  description: 'This page doesn’t exist, or it’s taken a different route. Let’s get you somewhere familiar.',
};
